/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Private_ProfileInputs */

const en_profile_private_profile = /** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Profile`)
};

const es_profile_private_profile = /** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil Privado`)
};

const fr_profile_private_profile = /** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil privé`)
};

const de_profile_private_profile = /** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privates Profil`)
};

const id_profile_private_profile = /** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil Pribadi`)
};

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const ja_profile_private_profile = en_profile_private_profile;

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const zh_profile_private_profile = en_profile_private_profile;

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const ar_profile_private_profile = en_profile_private_profile;

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const it_profile_private_profile = en_profile_private_profile;

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const ru_profile_private_profile = en_profile_private_profile;

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const pt_profile_private_profile = en_profile_private_profile;

/** @type {(inputs: Profile_Private_ProfileInputs) => LocalizedString} */
const ko_profile_private_profile = en_profile_private_profile;

/**
* | output |
* | --- |
* | "Private Profile" |
*
* @param {Profile_Private_ProfileInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_private_profile = /** @type {((inputs?: Profile_Private_ProfileInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Private_ProfileInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_private_profile(inputs)
	if (locale === "es") return es_profile_private_profile(inputs)
	if (locale === "fr") return fr_profile_private_profile(inputs)
	if (locale === "de") return de_profile_private_profile(inputs)
	if (locale === "ja") return ja_profile_private_profile(inputs)
	if (locale === "zh") return zh_profile_private_profile(inputs)
	if (locale === "ar") return ar_profile_private_profile(inputs)
	if (locale === "id") return id_profile_private_profile(inputs)
	if (locale === "it") return it_profile_private_profile(inputs)
	if (locale === "ru") return ru_profile_private_profile(inputs)
	if (locale === "pt") return pt_profile_private_profile(inputs)
	return ko_profile_private_profile(inputs)
});